<template>
  <footer class="footer">
    <div class="footer__container">
      <div class="footer__information">
        <div class="footer__services">
          <ButtonPrimary class="services__item"><router-link to="/locales">{{ $t('footer.txt_nuestra_cobertura') }}</router-link></ButtonPrimary>
          <ButtonPrimary class="services__item"><router-link to="/apply_job">{{ $t('footer.txt_trabaja_con_nosotros') }}</router-link></ButtonPrimary>
          <ButtonPrimary class="services__item"><a href="https://terminos.quickeat.pe" target="_blank">{{ $t('footer.txt_terminos_y_condiciones') }}</a></ButtonPrimary>
        </div>
        <div class="footer__content-socials">
          <div class="footer__socials">
            <p>{{ $t('footer.txt_siguenos_en') }}</p>
            <div>
              <div>
                <p @click="openLink('fb')" aria-label="Facebook" target="_blank" data-v-65d70315="">
                  <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M46.8693 25C46.8693 12.9221 37.0775 3.13028 24.9996 3.13028C12.9217 3.13028 3.12988 12.9221 3.12988 25C3.12988 35.9159 11.1269 44.9627 21.5821 46.6044V31.3218H16.0286V25H21.5821V20.1814C21.5821 14.7008 24.8465 11.6726 29.843 11.6726C32.2356 11.6726 34.7389 12.0998 34.7389 12.0998V17.4812H31.9819C29.2656 17.4812 28.4186 19.1666 28.4186 20.8958V24.9985H34.4838L33.5142 31.3203H28.4186V46.6029C38.8737 44.9627 46.8708 35.9144 46.8708 24.9985L46.8693 25Z" fill="currentColor"/>
                  </svg>
                </p>
              </div>
              <div>
                <p @click="openLink('instagram')" aria-label="Instagram" target="_blank" data-v-65d70315="">
                  <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M35.7333 16.879C35.4839 16.2361 35.1851 15.7783 34.7039 15.2957C34.2228 14.8145 33.7635 14.5157 33.1206 14.2663C32.635 14.0783 31.9061 13.8537 30.5633 13.7925C29.1111 13.7269 28.6752 13.7123 24.9996 13.7123C21.324 13.7123 20.8881 13.7269 19.4359 13.7925C18.0931 13.8537 17.3642 14.0783 16.8786 14.2663C16.2357 14.5157 15.7779 14.8145 15.2953 15.2957C14.8127 15.7768 14.5153 16.2361 14.2659 16.879C14.0779 17.3646 13.8533 18.0935 13.7921 19.4363C13.7265 20.8885 13.7119 21.3244 13.7119 25C13.7119 28.6756 13.7265 29.1115 13.7921 30.5637C13.8533 31.9065 14.0779 32.6354 14.2659 33.121C14.5153 33.7639 14.8141 34.2217 15.2953 34.7043C15.7764 35.1855 16.2357 35.4843 16.8786 35.7337C17.3642 35.9217 18.0931 36.1463 19.4359 36.2075C20.8881 36.2731 21.3226 36.2877 24.9996 36.2877C28.6766 36.2877 29.1126 36.2731 30.5633 36.2075C31.9061 36.1463 32.635 35.9217 33.1206 35.7337C33.7635 35.4843 34.2213 35.1855 34.7039 34.7043C35.1851 34.2232 35.4839 33.7639 35.7333 33.121C35.9213 32.6354 36.1459 31.9065 36.2071 30.5637C36.2727 29.1115 36.2873 28.6756 36.2873 25C36.2873 21.3244 36.2727 20.8885 36.2071 19.4363C36.1459 18.0935 35.9213 17.3646 35.7333 16.879ZM24.9996 32.0712C21.0951 32.0712 17.9284 28.9059 17.9284 25C17.9284 21.0941 21.0937 17.9288 24.9996 17.9288C28.9055 17.9288 32.0708 21.0941 32.0708 25C32.0708 28.9059 28.9055 32.0712 24.9996 32.0712ZM32.3493 19.3022C31.4366 19.3022 30.6974 18.563 30.6974 17.6503C30.6974 16.7376 31.4366 15.9984 32.3493 15.9984C33.262 15.9984 34.0012 16.7376 34.0012 17.6503C34.0012 18.563 33.262 19.3022 32.3493 19.3022Z" fill="currentColor"/>
                    <path d="M29.2391 26.7566C30.2091 24.4147 29.097 21.7298 26.7551 20.7598C24.4132 19.7898 21.7284 20.9019 20.7584 23.2437C19.7883 25.5856 20.9004 28.2705 23.2423 29.2405C25.5842 30.2106 28.269 29.0985 29.2391 26.7566Z" fill="currentColor"/>
                    <path d="M24.9996 3.13028C12.9217 3.13028 3.12988 12.9221 3.12988 25C3.12988 37.0779 12.9217 46.8697 24.9996 46.8697C37.0775 46.8697 46.8693 37.0779 46.8693 25C46.8693 12.9221 37.0775 3.13028 24.9996 3.13028ZM38.6871 30.6774C38.6201 32.1426 38.3868 33.1443 38.0471 34.0205C37.6957 34.9259 37.2248 35.6943 36.4593 36.4597C35.6939 37.2252 34.9255 37.6961 34.0201 38.0475C33.1439 38.3872 32.1437 38.6205 30.677 38.6875C29.2088 38.7546 28.7393 38.7706 24.9996 38.7706C21.2599 38.7706 20.7904 38.7546 19.3222 38.6875C17.8569 38.6205 16.8553 38.3872 15.9791 38.0475C15.0737 37.6961 14.3053 37.2252 13.5399 36.4597C12.7744 35.6943 12.3035 34.9259 11.9521 34.0205C11.6124 33.1443 11.3791 32.1441 11.3121 30.6774C11.245 29.2092 11.229 28.7397 11.229 25C11.229 21.2603 11.245 20.7908 11.3121 19.3226C11.3791 17.8573 11.6124 16.8557 11.9521 15.9795C12.3035 15.0741 12.7744 14.3057 13.5399 13.5403C14.3053 12.7748 15.0737 12.3039 15.9791 11.9525C16.8553 11.6128 17.8555 11.3795 19.3222 11.3125C20.7904 11.2454 21.2599 11.2294 24.9996 11.2294C28.7393 11.2294 29.2088 11.2454 30.677 11.3125C32.1422 11.3795 33.1439 11.6128 34.0201 11.9525C34.9255 12.3039 35.6939 12.7748 36.4593 13.5403C37.2248 14.3057 37.6957 15.0741 38.0471 15.9795C38.3868 16.8557 38.6201 17.8559 38.6871 19.3226C38.7542 20.7908 38.7702 21.2603 38.7702 25C38.7702 28.7397 38.7542 29.2092 38.6871 30.6774Z" fill="currentColor"/>
                  </svg>
                </p>
              </div>
              <!--            <div>-->
              <!--              <p aria-label="tik tok" @click="openLink('tiktok')" data-v-65d70315="">-->
              <!--                <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">-->
              <!--                  <path d="M24.9996 3.13028C12.9217 3.13028 3.12988 12.9221 3.12988 25C3.12988 37.0779 12.9217 46.8697 24.9996 46.8697C37.0775 46.8697 46.8693 37.0779 46.8693 25C46.8693 12.9221 37.0775 3.13028 24.9996 3.13028ZM37.0192 22.4966C36.2027 22.4966 35.4023 22.3873 34.6077 22.2065C33.2445 21.8945 31.9848 21.3405 30.8184 20.5736C30.7572 20.5342 30.693 20.4482 30.6289 20.4773C30.5458 20.5152 30.5895 20.6217 30.5895 20.696C30.588 23.8336 30.6012 26.9697 30.5837 30.1073C30.5705 32.3001 29.8736 34.2625 28.4375 35.9334C26.9125 37.7092 24.9748 38.7385 22.6493 39.0229C20.8575 39.2416 19.156 38.9179 17.542 38.1204C17.281 37.9906 17.0317 37.8404 16.7985 37.6655C16.7256 37.5999 16.6512 37.5343 16.5783 37.4701C16.4033 37.3943 16.2619 37.2674 16.1161 37.1508C14.6756 36.0092 13.6594 34.5687 13.101 32.8133C12.9071 32.2024 12.7861 31.5769 12.7263 30.9384C12.684 30.4762 12.6782 30.0125 12.7088 29.5518C12.7788 28.4889 13.0296 27.4684 13.4684 26.4959C13.9277 25.4797 14.5532 24.5772 15.3492 23.7986C16.2765 22.8903 17.3496 22.2109 18.5728 21.7706C19.3397 21.495 20.1285 21.3273 20.9435 21.2676C21.5325 21.2238 22.1186 21.2369 22.7047 21.3069C22.7835 21.3157 22.8301 21.3317 22.8287 21.4265C22.8228 21.7516 22.8228 22.0782 22.8199 22.4033C22.8257 22.4092 22.868 24.879 22.868 26.0089C22.868 26.0483 22.868 26.0891 22.8651 26.1285C22.8593 26.2422 22.8024 26.2801 22.6945 26.2495C22.3854 26.162 22.0676 26.1212 21.7483 26.1037C21.2526 26.0774 20.7642 26.1474 20.3005 26.3195C18.7463 26.8925 17.803 28.0064 17.6062 29.6451C17.4123 31.262 18.0494 32.5538 19.3937 33.4854C19.5059 33.5627 19.6226 33.6356 19.7275 33.7246C19.7523 33.7479 19.7786 33.7712 19.8034 33.7931C20.1154 33.917 20.4274 34.0424 20.7598 34.108C21.8139 34.3165 22.8083 34.1561 23.7239 33.5919C24.7809 32.9402 25.4049 31.9866 25.6236 30.7678C25.6644 30.5374 25.6717 30.3027 25.6717 30.0679C25.6717 23.7695 25.6717 17.471 25.6717 11.171C25.6717 10.878 25.6309 10.9144 25.9225 10.9144C27.3746 10.9144 28.8268 10.9144 30.2804 10.9144C30.3139 10.9144 30.3489 10.9144 30.3839 10.9144C30.5326 10.9174 30.5356 10.9174 30.5341 11.0675C30.5326 11.4043 30.6726 12.1945 30.6843 12.2572C31.3127 15.4415 35.0232 17.3893 36.1677 17.5614C36.4827 17.6095 36.799 17.6474 37.1198 17.6445C37.2525 17.6445 37.2568 17.6474 37.2568 17.7757C37.2568 18.0717 37.3152 21.1174 37.3137 22.2313C37.3137 22.4864 37.2787 22.4996 37.0221 22.4996L37.0192 22.4966Z" fill="currentColor"/>-->
              <!--                </svg>-->
              <!--              </p>-->
              <!--            </div>-->
            </div>
          </div>
          <img class="footer__book-claim" @click="$router.push('/libro_rec')" src="../assets/images-new/libro-reclamaciones.jpeg" alt="Libro de reclamaciones">
          <img class="footer__logo" @click="$router.push('/')" src="../assets/images-new/header__logo.svg" alt="Logo">
        </div>
        <div class="footer__libro_claim">
          <ButtonPrimary class="services__item"><a href="https://terminos.quickeat.pe" target="_blank">{{ $t('footer.txt_terminos_y_condiciones') }}</a></ButtonPrimary>
          <img class="footer__book-claim" @click="$router.push('/libro_rec')" src="../assets/images-new/libro-reclamaciones.jpeg" alt="Libro de reclamaciones">
        </div>
      </div>
      <hr>
      <p class="footer__copy">{{getBusinessName()}} © {{new Date().getFullYear()}} | <a @click="openLink('quick eat')">{{ $t('footer.txt_desarrollador_por') }} <strong>Quick eat!</strong></a></p>
    </div>
  </footer>
</template>

<script>
import ButtonPrimary from "@/components/new/buttons/ButtonPrimary.vue";

export default {
  name: "FooterComponent",
  components: {ButtonPrimary},
  data()  {
    return {
      icons_color: '#ffffff',
      whatsapp_phone: '',
    }
  },
  mounted() {
    this.getWhatsappPhone()
  },
  methods: {
    getBusinessName() {
      return process.env.VUE_APP_BUSINESS_COMERCIAL_NAME
    },
    getWhatsappPhone() {
      this.whatsapp_phone = process.env.VUE_APP_WHATSAPP_PHONE
    },
    openLink (to) {
      switch (to) {
        case 'fb':
          window.open('https://www.facebook.com/RestauranteCaporalLucyana', '_blank');
          break;
        case 'instagram':
          window.open('https://www.instagram.com/restaurant_caporal_lucyana/', '_blank');
          break;
        case 'whatsapp':
          window.open(`https://wa.me/+51${process.env.VUE_APP_WHATSAPP_PHONE}`, '_blank');
          break;
        case 'quick eat':
          window.open('https://www.quickeat.pe', '_blank')
          break
        case 'tiktok':
          window.open('https://www.tiktok.com/', '_blank')
              break
      }
    }
  }
}


</script>

<style scoped>
  .footer{
    background-image: url("https://quickeat.s3.us-west-2.amazonaws.com/local/Caporal/ux_web_files/footer-background.webp");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom;
    box-shadow: inset 10px 10px 5px 400px rgba(8, 141, 8, 0.75);
  }

  .footer__container{
    max-width: 1400px;
    margin-left: auto;
    margin-right: auto;
    padding: 25px 16px;
  }

  .footer__information{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;
    max-width: 1200px;
    margin-inline: auto;
  }

  .footer__services{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px
  }

  .footer__services button{
    background-color: #fecb00;
    border: 1px solid #fecb00;
  }

  .footer__services button:hover{
    background-color: #fed643;
    border: 1px solid #fed643;
  }

  .footer__services button:active{
    background-color: #ffc200;
    border: 1px solid #ffc200;
  }

  .services__item{
    font-size: 18px;
    border-radius: 8px;
    padding: 8px 10px;
    text-align: center;
    cursor: pointer;
  }

  .services__item > a{ color: var(--text-black); }

  .footer__content-socials{
    display: flex;
    flex-direction: column-reverse;
    gap: 16px
  }

  .footer__socials{
    font-size: 18px;
    text-align: center
  }

  .footer__logo{ display: none; }

  .footer__socials > p{
    font-size: 20px;
    width: fit-content;
    color: var(--text-white);
  }

  .footer__socials > div{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    color: var(--complementary-second);
  }

  .footer__socials svg{ cursor: pointer; }

  .footer__book-claim{
    width: 120px;
    aspect-ratio: 16/9;
    border-radius: 8px;
    cursor: pointer;
    margin-inline:auto
  }

  .footer__libro_claim{ display: none; }

  .footer__copy{
    color: var(--text-white);
    text-align: center
  }

  strong{ cursor: pointer; }

  @media only screen and (min-width: 768px){
    .footer__information{
      display: grid;
      grid-template-columns: auto 1fr auto;
      place-items: center;
    }

    .footer__services{
      grid-column: 1 / 2;
      grid-row: 1 / 2;
      align-items: flex-start;
    }

    .footer__content-socials .footer__book-claim{ display: none; }

    .footer__services > button:last-child{ display: none; }

    .footer__logo{ display: block; }

    .footer__socials > p{ display: none; }

    .footer__book-claim { margin-inline:0; }

    .footer__libro_claim{
      display: block;
    }

    .footer__libro_claim button{
      background-color: #fecb00;
      border: 1px solid #fecb00;
      margin-bottom: 16px;
    }

    .footer__libro_claim button:hover{
      background-color: #fed643;
      border: 1px solid #fed643;
    }

    .footer__libro_claim button:active{
      background-color: #ffc200;
      border: 1px solid #ffc200;
    }

    .footer__libro_claim img{ margin-inline: auto; }
  }

  @media only screen and (min-width: 1024px){
    .footer{
      position: relative;
      padding: 100px 16px 0px 16px;
    }

    .footer:before{
      content: '';
      position: absolute;
      background-color: var(--text-white);
      top: 0;
      left: 0;
      width: 100%;
      height: 5px;
    }

    .footer:after{
      content: '';
      position: absolute;
      background-color: var(--text-white);
      top: 0;
      left: 0;
      width: 100%;
      height: 125px;
      clip-path: polygon(0% 0%, 0% 82.5%, 1.69492% 84.3293%, 3.38983% 86.1385%, 5.08475% 87.9078%, 6.77966% 89.6179%, 8.47458% 91.25%, 10.1695% 92.7862%, 11.8644% 94.2098%, 13.5593% 95.505%, 15.2542% 96.6578%, 16.9492% 97.6555%, 18.6441% 98.487%, 20.339% 99.1435%, 22.0339% 99.6176%, 23.7288% 99.9041%, 25.4237% 100%, 27.1186% 99.9041%, 28.8136% 99.6176%, 30.5085% 99.1435%, 32.2034% 98.487%, 33.8983% 97.6555%, 35.5932% 96.6578%, 37.2881% 95.505%, 38.9831% 94.2098%, 40.678% 92.7862%, 42.3729% 91.25%, 44.0678% 89.6179%, 45.7627% 87.9078%, 47.4576% 86.1385%, 49.1525% 84.3293%, 50.8475% 82.5%, 52.5424% 80.6708%, 54.2373% 78.8616%, 55.9322% 77.0922%, 57.6271% 75.3821%, 59.322% 73.75%, 61.017% 72.2138%, 62.7119% 70.7902%, 64.4068% 69.495%, 66.1017% 68.3422%, 67.7966% 67.3446%, 69.4915% 66.513%, 71.1864% 65.8565%, 72.8814% 65.3824%, 74.5763% 65.0959%, 76.2712% 65%, 77.9661% 65.0959%, 79.661% 65.3824%, 81.3559% 65.8565%, 83.0509% 66.513%, 84.7458% 67.3446%, 86.4407% 68.3422%, 88.1356% 69.495%, 89.8305% 70.7902%, 91.5254% 72.2138%, 93.2203% 73.75%, 94.9153% 75.3821%, 96.6102% 77.0922%, 98.3051% 78.8616%, 100% 80.6708%, 100% 0%);
    }

    .footer__information{
      padding: 25px 16px;
    }

    .services__item{
      font-size: 22px;
      padding: 12px 10px
    }

    .footer__socials p{
      font-size: 24px;
    }
  }
</style>